module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "offset-lg-1 col-lg-10 col-sm-12"
  }, [_c('div', {
    staticClass: "step-form__main pt-3"
  }, [_c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "padding-left": "5px"
    }
  }, [_vm._v("Related Documents (optional)")])]), _vm._v(" "), (this.currentFiles.length > 0) ? _c('div', [_c('div', {
    staticClass: "field"
  }, _vm._l((_vm.currentFiles), function(file, index) {
    return _c('div', {
      key: index,
      staticClass: "file-item"
    }, [_c('div', {
      staticClass: "level-top row"
    }, [_c('div', {
      staticClass: "level-left col-lg-6"
    }, [_c('div', {
      staticClass: "global-h-gutter"
    }, [_c('svg', {
      attrs: {
        "width": "48",
        "height": "48",
        "fill": "none",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('circle', {
      attrs: {
        "cx": "24",
        "cy": "24",
        "r": "24",
        "fill": "#F0F4F0"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M17 16h14v17H17V16z",
        "fill": "#fff",
        "stroke": "#91C855",
        "stroke-width": "2"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M20.5 24.5h7M20.5 21.5h7M20.5 27.5h7",
        "stroke": "#91C855",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "level-item m-l-20"
    }, [_c('a', {
      attrs: {
        "href": ("" + (file.file_url))
      }
    }, [_vm._v(_vm._s(file.file_name))])])])]), _vm._v(" "), _c('div', {
      staticClass: "level-bot"
    }, [_c('select', {
      staticClass: "file-type",
      attrs: {
        "disabled": ""
      },
      on: {
        "change": function($event) {
          return _vm.onChange(file, $event)
        }
      }
    }, _vm._l((_vm.options), function(option, index) {
      return _c('option', {
        key: index
      }, [_vm._v("\n                    " + _vm._s(file.file_category) + "\n                  ")])
    }), 0)])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "review-section col-lg-12 row"
  }, [_c('div', {
    staticClass: "amcredit-text"
  }, [_vm._v("Upload any documents related to you or your business. Files must be PDF, JPEG, PNG, DOC or XLS, 25mb max.")]), _vm._v(" "), _c('div', {
    staticClass: "remove-padding col-lg-12"
  }, [_c('multiple-uploads', {
    key: _vm.fileUploadComponentKey,
    on: {
      "ready": function (childVal) {
        _vm.uploadedFiles = childVal
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('el-button', {
    staticClass: "personal-center-form__submit",
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("submit")])], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e7a36ff"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personalCenter/FileUpload.vue
// module id = 1948
// module chunks = 5